import { create } from "zustand";

export interface ActiveAppState {
  appId: string | null;
  title: string;
  subtitle: string;
  icon: string | null;
  iconColor: string;
  setActiveApp: (
    appId: string,
    title: string,
    subtitle: string,
    icon?: string,
    iconColor?: string
  ) => void;
  clearActiveApp: () => void;
}

export const useActiveAppStore = create<ActiveAppState>((set) => ({
  appId: null,
  title: "",
  subtitle: "",
  icon: null,
  iconColor: "",
  setActiveApp: (appId, title, subtitle, icon, iconColor) =>
    set({ appId, title, subtitle, icon: icon || null, iconColor: iconColor || "" }),
  clearActiveApp: () =>
    set({ appId: null, title: "", subtitle: "", icon: null, iconColor: "" }),
}));
